var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2772_18740)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "url(#paint0_linear_2772_18740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.0003 15.7601C5.89954 15.7602 3.88309 14.9338 2.38653 13.4595C0.889975 11.9852 0.0334406 9.98138 0.00195313 7.88086C0.00195312 7.92055 0.00195313 7.96355 0.00195313 8.00076C0.00195313 10.1225 0.844808 12.1573 2.3451 13.6576C3.84539 15.1579 5.88022 16.0008 8.00195 16.0008C10.1237 16.0008 12.1585 15.1579 13.6588 13.6576C15.1591 12.1573 16.002 10.1225 16.002 8.00076C16.002 7.96024 16.002 7.91807 16.002 7.88086C15.9705 9.98195 15.1135 11.9863 13.6162 13.4606C12.1189 14.935 10.1016 15.761 8.0003 15.7601Z",
    fill: "#FFED7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9997 0.300982C10.0953 0.301044 12.1073 1.1234 13.6029 2.59125C15.0986 4.0591 15.9586 6.05524 15.9981 8.15049C15.9981 8.10005 15.9981 8.05044 15.9981 8C15.9981 5.87827 15.1552 3.84344 13.6549 2.34315C12.1546 0.842855 10.1198 0 7.99805 0C5.87632 0 3.84148 0.842855 2.34119 2.34315C0.840902 3.84344 -0.00195312 5.87827 -0.00195312 8C-0.00195312 8.05044 -0.00195312 8.10005 -0.00195312 8.15049C0.0374791 6.05466 0.897937 4.05804 2.39433 2.59009C3.89073 1.12215 5.9035 0.300178 7.9997 0.300982Z",
    fill: "#FFED7D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 15.9627C12.3976 15.9627 15.9627 12.3976 15.9627 7.9999C15.9627 3.60217 12.3976 0.0371094 7.9999 0.0371094C3.60217 0.0371094 0.0371094 3.60217 0.0371094 7.9999C0.0371094 12.3976 3.60217 15.9627 7.9999 15.9627Z",
    fill: "url(#paint1_radial_2772_18740)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.9999 0.0292969C5.9246 0.0293968 3.93126 0.839373 2.44409 2.28686C0.956919 3.73434 0.0933325 5.70504 0.0371094 7.77958C0.917729 8.30134 2.30274 7.88377 3.20817 7.43064C3.98708 7.07095 4.9446 7.19085 5.78388 7.25121C7.88 7.43064 9.91825 8.32615 12.0127 7.79033C12.4319 7.67043 13.0306 7.12883 13.4498 7.49018C13.7966 7.77465 14.2177 7.9536 14.6631 8.00578C15.1085 8.05796 15.5596 7.98118 15.9627 7.78454C15.9077 5.70913 15.0447 3.73717 13.5574 2.28863C12.0701 0.840092 10.076 0.0294315 7.9999 0.0292969Z",
    fill: "url(#paint2_linear_2772_18740)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99942 14.5731C11.6299 14.5731 14.5731 11.6299 14.5731 7.99942C14.5731 4.3689 11.6299 1.42578 7.99942 1.42578C4.3689 1.42578 1.42578 4.3689 1.42578 7.99942C1.42578 11.6299 4.3689 14.5731 7.99942 14.5731Z",
    fill: "url(#paint3_linear_2772_18740)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00056 14.255C11.4548 14.255 14.255 11.4548 14.255 8.00056C14.255 4.54632 11.4548 1.74609 8.00056 1.74609C4.54632 1.74609 1.74609 4.54632 1.74609 8.00056C1.74609 11.4548 4.54632 14.255 8.00056 14.255Z",
    fill: "#FF8E20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00092 13.9999C11.3141 13.9999 13.9999 11.3141 13.9999 8.00092C13.9999 4.68778 11.3141 2.00195 8.00092 2.00195C4.68778 2.00195 2.00195 4.68778 2.00195 8.00092C2.00195 11.3141 4.68778 13.9999 8.00092 13.9999Z",
    fill: "url(#paint4_radial_2772_18740)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M7.99927 13.5519C4.73973 13.5519 2.08712 11.0795 2.00195 7.83984C2.00195 7.89276 2.00195 7.94568 2.00195 7.99943C2.00195 9.59045 2.63399 11.1163 3.75901 12.2413C4.88403 13.3664 6.40989 13.9984 8.00092 13.9984C9.59194 13.9984 11.1178 13.3664 12.2428 12.2413C13.3679 11.1163 13.9999 9.59045 13.9999 7.99943C13.9999 7.94568 13.9999 7.89276 13.9999 7.83984C13.9114 11.0795 11.2596 13.5519 7.99927 13.5519Z",
    fill: "#FFED7D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M8.19633 15.3568C10.529 15.3568 12.42 13.5131 12.42 11.2389C12.42 8.96471 10.529 7.12109 8.19633 7.12109C5.86366 7.12109 3.97266 8.96471 3.97266 11.2389C3.97266 13.5131 5.86366 15.3568 8.19633 15.3568Z",
    fill: "url(#paint5_radial_2772_18740)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M7.91703 9.77472C10.2497 9.77472 12.1407 7.93111 12.1407 5.65689C12.1407 3.38268 10.2497 1.53906 7.91703 1.53906C5.58436 1.53906 3.69336 3.38268 3.69336 5.65689C3.69336 7.93111 5.58436 9.77472 7.91703 9.77472Z",
    fill: "url(#paint6_radial_2772_18740)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5133 7.24587C12.4575 7.24587 12.3905 7.23457 12.3347 7.23457C11.0514 7.23457 9.76804 7.23457 8.48469 7.24587C8.39541 7.25717 8.3173 7.31367 8.27266 7.39277C7.77048 8.26285 7.77048 8.26285 8.18338 9.18943C8.19454 9.20073 8.19454 9.23462 8.2057 9.23462C8.28382 9.29112 8.37309 9.39282 8.46237 9.39282C8.91991 9.40412 9.37746 9.40412 9.84616 9.40412H10.3483C10.3037 9.49452 10.2479 9.57362 10.1921 9.65271C9.56717 10.3194 8.79716 10.7036 7.88207 10.6584C6.91119 10.6132 6.20814 10.0708 5.76175 9.25722C5.23725 8.30805 4.32217 8.04815 3.41824 7.72046C3.23969 8.95213 3.86463 10.8392 5.53856 11.8901C7.23482 12.9748 9.41093 12.8279 10.9621 11.5511C12.3682 10.3646 12.8481 8.46624 12.5133 7.24587ZM6.79959 5.90121C7.1567 5.75431 7.53613 5.63001 7.91555 5.60742C8.94223 5.53962 9.74572 5.99161 10.3483 6.86168L12.2231 6.1385C11.4978 4.38705 9.73456 3.27967 7.81512 3.39267C6.25278 3.47177 5.02522 4.18365 4.11014 5.50572C4.51188 5.66391 4.88015 5.76561 5.21494 5.93511C5.76175 6.2063 6.26394 6.1272 6.79959 5.90121ZM5.67248 6.68089C5.72828 6.70349 5.81755 6.62439 5.88451 6.59049L5.86219 6.50009C5.27073 6.2741 4.67928 6.0368 4.08782 5.81081C4.02086 5.78821 3.92043 5.84471 3.84231 5.86731L3.85347 5.98031C4.45608 6.2176 5.06986 6.45489 5.67248 6.68089ZM3.51868 7.43797C4.11014 7.67526 4.71275 7.91256 5.31537 8.13855L5.38233 8.08205C5.33769 8.00295 5.31537 7.88996 5.24841 7.86736C4.66812 7.63006 4.0655 7.40407 3.47404 7.17808L3.38477 7.23457C3.44056 7.31367 3.46288 7.41537 3.51868 7.43797ZM3.81999 6.50009C4.33333 6.69219 4.85783 6.89558 5.37117 7.09898C5.5274 7.16678 5.60552 7.13288 5.60552 6.92948L3.75303 6.2176C3.61912 6.3758 3.6526 6.44359 3.81999 6.50009ZM3.63028 6.95208C4.21057 7.18938 4.79087 7.41537 5.37117 7.63006L5.43813 7.57357C5.39349 7.50577 5.37117 7.38147 5.30421 7.35887C4.73507 7.13288 4.16594 6.91818 3.60796 6.69219L3.52984 6.72609C3.56332 6.80519 3.57448 6.92948 3.63028 6.95208Z",
    fill: "url(#paint7_linear_2772_18740)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5133 7.24587C12.4575 7.24587 12.3905 7.23457 12.3347 7.23457C11.0514 7.23457 9.76804 7.23457 8.48469 7.24587C8.39541 7.25717 8.3173 7.31367 8.27266 7.39277C7.77048 8.26285 7.77048 8.26285 8.18338 9.18943C8.19454 9.20073 8.19454 9.23462 8.2057 9.23462C8.28382 9.29112 8.37309 9.39282 8.46237 9.39282C8.91991 9.40412 9.37746 9.40412 9.84616 9.40412H10.3483C10.3037 9.49452 10.2479 9.57362 10.1921 9.65271C9.56717 10.3194 8.79716 10.7036 7.88207 10.6584C6.91119 10.6132 6.20814 10.0708 5.76175 9.25722C5.23725 8.30805 4.32217 8.04815 3.41824 7.72046C3.23969 8.95213 3.86463 10.8392 5.53856 11.8901C7.23482 12.9748 9.41093 12.8279 10.9621 11.5511C12.3682 10.3646 12.8481 8.46624 12.5133 7.24587ZM6.79959 5.90121C7.1567 5.75431 7.53613 5.63001 7.91555 5.60742C8.94223 5.53962 9.74572 5.99161 10.3483 6.86168L12.2231 6.1385C11.4978 4.38705 9.73456 3.27967 7.81512 3.39267C6.25278 3.47177 5.02522 4.18365 4.11014 5.50572C4.51188 5.66391 4.88015 5.76561 5.21494 5.93511C5.76175 6.2063 6.26394 6.1272 6.79959 5.90121ZM5.67248 6.68089C5.72828 6.70349 5.81755 6.62439 5.88451 6.59049L5.86219 6.50009C5.27073 6.2741 4.67928 6.0368 4.08782 5.81081C4.02086 5.78821 3.92043 5.84471 3.84231 5.86731L3.85347 5.98031C4.45608 6.2176 5.06986 6.45489 5.67248 6.68089ZM3.51868 7.43797C4.11014 7.67526 4.71275 7.91256 5.31537 8.13855L5.38233 8.08205C5.33769 8.00295 5.31537 7.88996 5.24841 7.86736C4.66812 7.63006 4.0655 7.40407 3.47404 7.17808L3.38477 7.23457C3.44056 7.31367 3.46288 7.41537 3.51868 7.43797ZM3.81999 6.50009C4.33333 6.69219 4.85783 6.89558 5.37117 7.09898C5.5274 7.16678 5.60552 7.13288 5.60552 6.92948L3.75303 6.2176C3.61912 6.3758 3.6526 6.44359 3.81999 6.50009ZM3.63028 6.95208C4.21057 7.18938 4.79087 7.41537 5.37117 7.63006L5.43813 7.57357C5.39349 7.50577 5.37117 7.38147 5.30421 7.35887C4.73507 7.13288 4.16594 6.91818 3.60796 6.69219L3.52984 6.72609C3.56332 6.80519 3.57448 6.92948 3.63028 6.95208Z",
    fill: "url(#paint8_linear_2772_18740)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2772_18740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5133 7.24587C12.4575 7.24587 12.3905 7.23457 12.3347 7.23457C11.0514 7.23457 9.76804 7.23457 8.48469 7.24587C8.39541 7.25717 8.3173 7.31367 8.27266 7.39277C7.77048 8.26285 7.77048 8.26285 8.18338 9.18943C8.19454 9.20073 8.19454 9.23462 8.2057 9.23462C8.28382 9.29112 8.37309 9.39282 8.46237 9.39282C8.91991 9.40412 9.37746 9.40412 9.84616 9.40412H10.3483C10.3037 9.49452 10.2479 9.57362 10.1921 9.65271C9.56717 10.3194 8.79716 10.7036 7.88207 10.6584C6.91119 10.6132 6.20814 10.0708 5.76175 9.25722C5.23725 8.30805 4.32217 8.04815 3.41824 7.72046C3.23969 8.95213 3.86463 10.8392 5.53856 11.8901C7.23482 12.9748 9.41093 12.8279 10.9621 11.5511C12.3682 10.3646 12.8481 8.46624 12.5133 7.24587ZM6.79959 5.90121C7.1567 5.75431 7.53613 5.63001 7.91555 5.60742C8.94223 5.53962 9.74572 5.99161 10.3483 6.86168L12.2231 6.1385C11.4978 4.38705 9.73456 3.27967 7.81512 3.39267C6.25278 3.47177 5.02522 4.18365 4.11014 5.50572C4.51188 5.66391 4.88015 5.76561 5.21494 5.93511C5.76175 6.2063 6.26394 6.1272 6.79959 5.90121ZM5.67248 6.68089C5.72828 6.70349 5.81755 6.62439 5.88451 6.59049L5.86219 6.50009C5.27073 6.2741 4.67928 6.0368 4.08782 5.81081C4.02086 5.78821 3.92043 5.84471 3.84231 5.86731L3.85347 5.98031C4.45608 6.2176 5.06986 6.45489 5.67248 6.68089ZM3.51868 7.43797C4.11014 7.67526 4.71275 7.91256 5.31537 8.13855L5.38233 8.08205C5.33769 8.00295 5.31537 7.88996 5.24841 7.86736C4.66812 7.63006 4.0655 7.40407 3.47404 7.17808L3.38477 7.23457C3.44056 7.31367 3.46288 7.41537 3.51868 7.43797ZM3.81999 6.50009C4.33333 6.69219 4.85783 6.89558 5.37117 7.09898C5.5274 7.16678 5.60552 7.13288 5.60552 6.92948L3.75303 6.2176C3.61912 6.3758 3.6526 6.44359 3.81999 6.50009ZM3.63028 6.95208C4.21057 7.18938 4.79087 7.41537 5.37117 7.63006L5.43813 7.57357C5.39349 7.50577 5.37117 7.38147 5.30421 7.35887C4.73507 7.13288 4.16594 6.91818 3.60796 6.69219L3.52984 6.72609C3.56332 6.80519 3.57448 6.92948 3.63028 6.95208Z",
    fill: "url(#paint9_linear_2772_18740)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40765 7.80558C3.44734 7.8762 3.47153 7.9511 3.5186 7.97026C4.10716 8.2064 4.70691 8.4425 5.30657 8.6675C5.47816 8.82946 5.63198 9.02231 5.7618 9.25725C6.20816 10.0707 6.91117 10.6131 7.88192 10.6583C8.65754 10.6966 9.32844 10.4256 9.89561 9.93645H10.3484C10.3038 10.0268 10.2478 10.1059 10.192 10.185C9.56711 10.8517 8.79701 11.236 7.88192 11.1908C6.91117 11.1456 6.20816 10.6033 5.7618 9.78979C5.23732 8.84066 4.32228 8.5805 3.4184 8.25283C3.41066 8.30617 3.40472 8.36081 3.40002 8.41648C3.38348 8.202 3.38615 7.99669 3.40765 7.80558Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3347 7.23455C12.3905 7.23455 12.4575 7.24564 12.5133 7.24564C12.6019 7.56868 12.6327 7.93927 12.6051 8.33154C12.5906 8.13624 12.5605 7.95039 12.5133 7.77819C12.4575 7.77818 12.3905 7.76709 12.3347 7.76709C11.0514 7.76709 9.76813 7.76689 8.48485 7.77819C8.39557 7.78949 8.3173 7.84609 8.27266 7.92519C8.10301 8.21913 7.9917 8.41413 7.93324 8.57874C7.81256 8.19108 7.9143 8.01355 8.27266 7.39265C8.3173 7.31355 8.39557 7.25694 8.48485 7.24564C9.76813 7.23435 11.0514 7.23455 12.3347 7.23455Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88333 7.3344C4.34133 7.50887 4.8015 7.68458 5.24832 7.86729C5.25347 7.86903 5.25789 7.87217 5.26254 7.87492C4.80055 7.69191 4.33899 7.51534 3.88333 7.3344Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44405 7.7293L3.41493 7.74768C3.41616 7.73855 3.41708 7.72935 3.4184 7.72029C3.42692 7.72338 3.43553 7.72622 3.44405 7.7293Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98492 7.09517C4.41129 7.25596 4.84373 7.42346 5.26947 7.59166C4.8413 7.43227 4.41309 7.26686 3.98492 7.09517Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60215 7.22692L3.52969 7.25847C3.56108 7.33263 3.57355 7.44572 3.62087 7.47829C3.58683 7.46466 3.55257 7.45135 3.5186 7.43772C3.4629 7.41504 3.44049 7.31358 3.38477 7.23455L3.47387 7.17804C3.51653 7.19434 3.55939 7.21062 3.60215 7.22692Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39429 7.10765C5.38686 7.10478 5.37888 7.10238 5.37106 7.09899C5.36368 7.09606 5.35625 7.09324 5.34887 7.09032C5.36403 7.09606 5.37914 7.10192 5.39429 7.10765Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75297 6.74985C3.648 6.87386 3.64651 6.94153 3.73113 6.99255C3.69757 6.9789 3.66379 6.9657 3.63024 6.95198C3.57446 6.92936 3.56316 6.80502 3.52969 6.72593L3.60805 6.69195C3.65622 6.71146 3.70464 6.73049 3.75297 6.74985Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60543 6.92945C5.60543 6.93037 5.60509 6.9313 5.60509 6.93222C5.33879 6.8292 5.07188 6.72612 4.80558 6.62192L5.60543 6.92945Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08789 5.81062C4.13636 5.82914 4.18469 5.84812 4.23316 5.86678C4.19158 5.92272 4.15045 5.97974 4.11008 6.03806C4.51182 6.19625 4.88025 6.29813 5.21504 6.46763C5.41804 6.56829 5.61495 6.62023 5.80965 6.63474C5.75991 6.66603 5.70901 6.6957 5.67235 6.68086C5.06977 6.45487 4.45609 6.21744 3.85352 5.98016L3.84242 5.86713C3.92052 5.84451 4.02097 5.78803 4.08789 5.81062Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07333 6.34039C4.00698 6.32904 3.91512 6.37862 3.84242 6.39968L3.85317 6.51236C3.84211 6.50821 3.83094 6.50401 3.81988 6.49987C3.65259 6.44338 3.61909 6.37547 3.75297 6.21731L4.07333 6.34039Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81501 3.39267C9.73441 3.27968 11.4977 4.38687 12.2231 6.13826L12.0064 6.22181C11.1841 4.73332 9.56463 3.82222 7.81501 3.92522C6.42531 3.9956 5.30051 4.56653 4.42489 5.62235C4.32239 5.5858 4.21736 5.54776 4.11008 5.50551C5.02514 4.18349 6.25273 3.4718 7.81501 3.39267Z",
    fill: "#FFFBE0",
    fillOpacity: 0.29
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2772_18740",
    x: 2.38477,
    y: 3.38477,
    width: 11.2305,
    height: 11.7305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5625 0 0 0 0 0.15 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2772_18740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2772_18740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2772_18740",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFDF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFE64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFE955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9D23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2772_18740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.9197 -1.10067) scale(6.37106 6.37106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2772_18740",
    x1: 7.9999,
    y1: 14.6674,
    x2: 7.9999,
    y2: 3.05813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2772_18740",
    x1: 7.99942,
    y1: 14.5731,
    x2: 7.99942,
    y2: -1.57908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFCC26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFAF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA423"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2772_18740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.64288 1.9788) scale(13.9742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDD41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56316"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2772_18740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.19633 11.2389) scale(4.17075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99230D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23416",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2772_18740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.91703 5.65689) scale(4.17075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D72D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE5D22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2772_18740",
    x1: 5.17948,
    y1: 2.12949,
    x2: 12.0757,
    y2: 16.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA6119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C94B13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B22E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A92308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2772_18740",
    x1: 5.17948,
    y1: 2.12908,
    x2: 12.0713,
    y2: 16.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA6119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C94B13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B22E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A92308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2772_18740",
    x1: 7.8874,
    y1: 2.35558,
    x2: 8.08355,
    y2: 14.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2772_18740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.f587e49fec585ebcb1ee367fe6d44569.svg";
export { ForwardRef as ReactComponent };